module.exports = __webpack_public_path__ + "static/media/Mayor Lightfoot at CAN event 07-31-19.1aa5185e.jpg";